import { api } from '@smena/ui';

export type StepId =
  | 'account'
  | 'source'
  | 'properties'
  | 'avito'
  | 'property_form'
  | 'chat_import'
  | 'channels'
  | 'persona'
  | 'demo_chat'
  | 'switches';

export const STEPS: StepId[] = [
  'account',
  'source',
  'properties',
  'avito',
  'property_form',
  'chat_import',
  'channels',
  'persona',
  'demo_chat',
  'switches',
];

export const STEP_META: Record<StepId, { title: string; est: string; hint: string }> = {
  account: { title: 'Аккаунт', est: '1 мин', hint: 'Название УК и контакты' },
  source: { title: 'Источник броней', est: '3 мин', hint: 'Откуда прилетают брони' },
  properties: { title: 'Объекты', est: '2 мин', hint: 'Список квартир для управления' },
  avito: {
    title: 'Авито (опционально)',
    est: '2 мин',
    hint: 'Импорт объявлений + история чатов; позже - автоответы в мессенджере',
  },
  property_form: { title: 'Анкета объекта', est: '5 мин', hint: 'Wi-Fi, замок, домофон, экстренные' },
  chat_import: { title: 'Импорт переписок', est: '2 мин', hint: 'Файлы TXT/HTML/JSON или из Авито' },
  channels: {
    title: 'Каналы гостя',
    est: '1 мин',
    hint: 'Общий бот Smena из коробки или подключите свой Telegram-бот',
  },
  persona: { title: 'Персона агента', est: '2 мин', hint: 'Имя, тон общения' },
  demo_chat: { title: 'Демо-чат', est: '2 мин', hint: 'Проверить как отвечает агент' },
  switches: { title: 'Финальные рубильники', est: '1 мин', hint: 'Включить draft-режим, welcome, Control' },
};

export interface SetupState {
  currentStep: number;
  completed: StepId[];
  skipped: StepId[];
  completedAt: string | null;
  /** Живой признак: пришла ли хоть одна бронь через RC-webhook. Пока false - шаг source нельзя завершить. */
  sourceReady: boolean;
}

export async function fetchSetupState(): Promise<SetupState> {
  return api('/api/staff/setup/state');
}

export async function markStep(id: StepId, action: 'completed' | 'skipped' | 'reopen'): Promise<SetupState> {
  return api('/api/staff/setup/step', { method: 'POST', json: { id, action } });
}

export async function resetSetup(): Promise<SetupState> {
  return api('/api/staff/setup/reset', { method: 'POST', json: {} });
}
